import type { ContainerType } from "~/container";
import type { IApi } from "~/interfaces/IApi";
import type { IReportSubcategoryService } from "@saif-reporting/domain/interfaces/services/IReportSubcategoryService.js";
import type { ReportSubcategoryDto } from "@saif-reporting/domain/dtos/models/ReportSubcategoryDto.js";

export class ReportSubcategoryService implements IReportSubcategoryService {
  private readonly api: IApi;
  constructor({ baseApi }: ContainerType) {
    this.api = baseApi;
  }

  async getList(): Promise<ReportSubcategoryDto[]> {
    return await this.api.$fetch<ReportSubcategoryDto[]>("/report-subcategories");
  }
}
